import React from "react";
import { Button, Card, Input, Label, Row, Col } from "reactstrap";
import { useState } from "react";
import Select from "react-select";
// import DataTable from "react-data-table-component";
import { DataTable } from "primereact/datatable";
import { useEffect } from "react";

import BreadCrumb from "../../Components/BreadCrumbComp";
import Notiflix from "notiflix";
import { useNavigate } from "react-router-dom";
import { Activity, Download, Edit, Eye } from "react-feather";
import moment from "moment";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import { toast } from "react-toastify";
import PostApiCall from "../../Api/Api";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { Column } from "primereact/column";
import CustomDataTable from "../../Components/CustomDataTable";
import CommonModal from "../../Components/CommonModal";
import Jobtemplate from "./Jobtemplate";


const CityMailer = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null)
  const handalModal = (data) => {
    setModalData(data)
    setShowModal(true)

  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const columns = [
    {
      field: "fld_code",
      header: "Code",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      field: "fld_title",
      header: "Title",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_city",
      header: "City",
      sortable: true,
      headerStyle: { width: "120px", minWidth: "120px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },

    {
      field: "fld_company",
      header: "Client Name",
      sortable: true,
      headerStyle: { width: "180px", minWidth: "180px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_openingdate",
      header: "Opening Date",
      sortable: true,
      body: (rowData) => moment(rowData.fld_openingdate).format("ll"),
      headerStyle: { width: "120px", minWidth: "120px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },

    {
      field: "fld_closingdate",
      header: "Closing Date",
      sortable: true,
      body: (rowData) => {
        const closingDate = moment(rowData.fld_closingdate);
        const isClosed = closingDate.isBefore(moment(), "day");

        return (
          <>


            <div>
              {isClosed ? (
                <span>
                  {closingDate.format("ll")}{" "}
                  <sup className="text-danger">Closed</sup>
                </span>
              ) : (
                closingDate.format("ll")
              )}
            </div>
          </>

        );
      },
      headerStyle: { width: "120px", minWidth: "120px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },

    {
      field: "fld_status",
      header: "Status",
      sortable: true,
      body: (rowData) => (
        <span
          className={`py-1 px-2 ${rowData.fld_status === "Active" ? "BlueWhite" : "OrangeWhite"
            }`}
        >
          {rowData.fld_status}
        </span>
      ),
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_approved",
      header: "Approval Status",
      sortable: true,
      body: (rowData) => (
        <span
          className={`py-1 px-2 ${rowData.fld_approved === "Yes" ? "GreenWhite" : "OrangeWhite"
            }`}
        >
          {rowData.fld_approved === "Yes" ? "Approved" : "Pending"}
        </span>
      ),
      headerStyle: { width: "120px", minWidth: "120px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    // {
    //   header: "Action",
    //   body: (rowData, history) => (
    //     <div
    //       style={{
    //         display: "flex",
    //         flexDirection: "row",
    //         justifyContent: "center",
    //         alignItems: "center",
    //       }}
    //     >
    //       {/* View Button */}
    //       <span
    //         className="btnsAudit"
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           history({ pathname: "/view-publish-job", state: rowData });
    //         }}
    //         style={{
    //           textTransform: "capitalize",
    //           fontSize: "11px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         <Eye size={15} /> View
    //       </span>

    //       {/* Status Toggle Button */}
    //       <span
    //         className={`btnsAudit ml-2 ${rowData?.fld_status === "Active" ? "dangerAudit" : "successAudit"}`}
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           Notiflix.Confirm.show(
    //             "Change Status",
    //             `Are you sure you want to ${rowData?.fld_status === "Active" ? "deactivate" : "activate"} this job posting?`,
    //             "Yes",
    //             "No",
    //             () => changeStatusHandler(rowData),
    //             () => { }
    //           );
    //         }}
    //         style={{
    //           textTransform: "capitalize",
    //           fontSize: "11px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         <Activity size={15} />{" "}
    //         {rowData?.fld_status === "Active" ? "InActive" : "Active"} Status
    //       </span>

    //       {/* Template Button */}
    //       <span
    //         className="btnsAudit ml-2"
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           handalModal(rowData);
    //         }}
    //         style={{
    //           textTransform: "capitalize",
    //           fontSize: "11px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Template
    //       </span>

    //       {/* City Mailer Button */}
    //       <span
    //         className="btnsAudit ml-2"
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           history.push({
    //             pathname: `/mail-auditors/${rowData.fld_id}`,
    //             state: { jobDetails: rowData },
    //           });
    //         }}
    //         style={{
    //           textTransform: "capitalize",
    //           fontSize: "11px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Mail Auditors
    //       </span>
    //       <span
    //         className="btnsAudit ml-2"
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           history.push({
    //             pathname: `/city-mailers/${rowData.fld_id}`,
    //             state: { jobDetails: rowData },
    //           });
    //         }}
    //         style={{
    //           textTransform: "capitalize",
    //           fontSize: "11px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         City Mailers
    //       </span>
    //     </div>
    //   ),
    //   headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
    //   bodyStyle: { width: "200px", minWidth: "200px" },
    // }
  ];

  const user = useSelector((state) => state.login);

  const history = useNavigate();

  const [jobData, setjobData] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [filterJobData, setFilterJobData] = useState(jobData);
  const [modalOpen, setModalOpen] = useState(false);
  const [ErrorModal, setErrorModal] = useState({ open: false, error: [] });
  const [cityOption, setCityOption] = useState([]);
  const [selectedCity, setSelectedCity] = useState({ value: "All", label: "All" });
  const [sendingMail, setSendingMail] = useState(false);
  const [mailModalOpen, setMailModalOpen] = useState(false);
//   const updateSearchQuery = (value) => {
//     setSearchVal(value);
//     filterMethod(value); 
//   };

  const filterMethod = (search, city) => {
    const result = jobData.filter((item) => {
      const searchMatches = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      );
      const cityMatches = !city || item.fld_city === city.value || city.value === "All";
      return searchMatches && cityMatches;
    });
    setFilterJobData(result);
  };

  const updateSearchQuery = (value) => {
    setSearchVal(value);
    filterMethod(value, selectedCity);
  };

  const updateFilterCity = (selectedOption) => {
    setSelectedCity(selectedOption);
    filterMethod(searchVal, selectedOption);
  };


  const getJobOpening = async () => {
    Notiflix.Loading.standard();
    try {
      const payload = {
        usertype: user ? user.fld_usertype : null,
      };
      const json = await PostApiCall.postRequest(payload, "GetAllJobOpening");
      const res = await json.json();

      setjobData(res?.data);
      setFilterJobData(res?.data);

      // Extract unique cities
      const uniqueCities = Array.from(
        new Set(
          res?.data
            ?.map((ele) => ele?.fld_city)
            .filter((ele) => ele !== null)
        )
      ).map((city) => ({ value: city, label: city }));

      setCityOption([{ value: "All", label: "All" }, ...uniqueCities]);
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    Notiflix.Loading.remove();
  };
  useEffect(() => {
    // Notiflix.Loading.init({ svgColor: "#c16d18" });

    getJobOpening();
  }, []);

  const handleDownload = () => {
    const templateData = [
      {
        title: "",
        type: "",
        category: "",
        area: "",
        country: "India",
        state: "",
        city: "",
        pincode: "",
        jobdescription:
          "<ul>\n\t<li>Brief description -</li>\n\t<li>Whether Checklist based (Y/N) -</li>\n\t<li>Whether App based (Y/N) -&nbsp;</li>\n\t<li>Whether HHD based (Y/N) -&nbsp;</li>\n\t<li>Gender preference -&nbsp;</li>\n\t<li>Mandatory reporting time at audit location -&nbsp;</li>\n\t<li>Report submission timelines -&nbsp;</li>\n\t<li>Phone Requirement (Android / IOS) -&nbsp;</li>\n\t<li>Photographs requirements -&nbsp;</li>\n\t<li>Training requirement</li>\n</ul>\n",

        skillset:
          '<p>A.&nbsp;&nbsp; &nbsp;Payment Terms:</p>\n\n<ol>\n\t<li>&nbsp;For Payment related queries reach only to <a href="mailto:support@beteljobs.com">support@beteljobs.com</a> or through WhatsApp Number 9319179297</li>\n\t<li>Do not discuss and disclose fee with the client/any other team member.</li>\n\t<li>Payment will be made within 7 working days from the completion of assignment and confirmation by client.</li>\n\t<li>Fee will not be paid in case auditor leave or backout from the assignment before completion of the assignment.&nbsp;</li>\n\t<li>If candidate is late by more than 30 minute than his fee can be reduced by 50%.&nbsp;</li>\n\t<li>Inform us regarding any changes in planned mandays, travelling reimbursement etc. instructed by clients.We will not be responsible for non-payment of additional&nbsp;mandays or travelling reimbursement if not informed to us in advance and done only based on instruction of client.</li>\n</ol>\n\n<p>B.&nbsp;&nbsp; &nbsp;Other Terms:&nbsp;</p>\n\n<ol>\n\t<li>Normal working duration will be 9 hours until otherwise informed specifically.</li>\n\t<li>&nbsp;Full details of the assignment shall be provided by us.&nbsp;</li>\n\t<li>Actual assignment date and duration may vary.&nbsp;</li>\n\t<li>You cannot dropout of assignment once training given or 1 day before assignment whichever is earlier.&nbsp;</li>\n\t<li>Dress code is Formal. Sleeper, hoodies etc. are not allowed.</li>\n</ol>\n',

        company: "",
        // experience: "",
        // duties: "",
        // employername: "",
        // employerdesignation: "",
        // employeremail: "",
        // employermobile: "",
        // approved: "",
        minsalary: 0,
        maxsalary: "",
        salarytype: "",
        minexperience: 0,
        maxexperience: "",
        experiencetype: "",
        positions: "",
        remotework: "",
        openingdate: "",
        closingdate: "",
        status: "Active",

        qualification: "",
        address: "",
        assignduration: "",
        laptop: "No",
        vehicle: "No",
        auditdate: "",
        auditenddate: "",
        auditenddatetype: "No",
        projectcoordinatoremail: "",
        projectcoordinatorname: "",
      },
    ];

    const ws = XLSX.utils.json_to_sheet(templateData);

    // Define custom column headers
    const headers = [
      [
        "Title",
        "Job Type",
        "Industry Type",
        "Preference City",
        "Country",
        "State",
        "City",
        "Pincode",
        "Job Description",
        // "Duties",
        "General Terms",
        // "Experience",
        "Client Name",
        // "Employer Name",
        // "Employer Designation",
        // "Employer Email",
        // "Employer Mobile",
        "Minimum Salary",
        "Maximum Salary",
        "Salary Type",
        "Minimum Experience",
        "Maximum Experience",
        "Experience Type",
        "On of Positions",
        "Remote Work",
        "Opening Date (DD-MM-YYYY)",
        "Closing Date (DD-MM-YYYY)",
        "Status",
        // "Approved",
        "Qualification",
        "Address",
        "Assignment Duration",
        "Laptop Requirement",
        "Vehicle Requirement",
        "Audit Start Date (DD-MM-YYYY)",
        "Audit End Date (DD-MM-YYYY)",
        "Audit Date Fixed (Yes/No)",
        "Project Coordinator Name",
        "Project Coordinator Email",
      ],
    ];

    // Add headers to the worksheet
    XLSX.utils.sheet_add_aoa(ws, headers, { origin: "A1" });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");

    // Create a Blob and trigger download
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "base64" });
    const href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${wbout}`;

    const link = document.createElement("a");
    link.href = href;
    link.download = "Template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [excelData, setExcelData] = useState([]);
  function convertExcelDate(serial) {
    const excelStartDate = new Date(Date.UTC(1899, 11, 30)); // Excel's epoch in UTC
    const convertedDate = new Date(
      excelStartDate.getTime() + serial * 86400000
    );

    // Return correct YYYY-MM-DD format in UTC
    return convertedDate.toISOString().split("T")[0];
  }
  const formatDate = (date) => {
    return moment(date, ["DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD"], true).format("YYYY-MM-DD");
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (!file) return;

    Notiflix.Loading.standard();

    if (file.size > 5000000) {
      Notiflix.Notify.failure("File too large, upload a file less than 5 MB.");
      Notiflix.Loading.remove();
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Get first sheet name and extract data
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" }); // Convert to JSON

        // Convert Excel serial date numbers to JavaScript dates
        jsonData.forEach((row) => {
          if (typeof row["Closing Date (DD-MM-YYYY)"] === "number") {
            row["Closing Date (DD-MM-YYYY)"] = convertExcelDate(
              row["Closing Date (DD-MM-YYYY)"]
            );
          }
          if (typeof row["Opening Date (DD-MM-YYYY)"] === "number") {
            row["Opening Date (DD-MM-YYYY)"] = convertExcelDate(
              row["Opening Date (DD-MM-YYYY)"]
            );
          }
          if (typeof row["Audit Start Date (DD-MM-YYYY)"] === "number") {
            row["Audit Start Date (DD-MM-YYYY)"] = convertExcelDate(
              row["Audit Start Date (DD-MM-YYYY)"]
            );
          }
          if (typeof row["Audit End Date (DD-MM-YYYY)"] === "number") {
            row["Audit End Date (DD-MM-YYYY)"] = convertExcelDate(
              row["Audit End Date (DD-MM-YYYY)"]
            );
          }
        });

        const updatedData = jsonData.map((item) => ({
          title: item["Title"],
          type: item["Job Type"],
          category: item["Industry Type"],
          area: item["Preference City"],
          country: item["Country"],
          state: item["State"],
          city: item["City"],
          pincode: item["Pincode"],
          jobdescription: item["Job Description"],
          skillset: item["General Terms"],
          company: item["Client Name"],
          minsalary: item["Minimum Salary"] || 0,
          maxsalary: item["Maximum Salary"] || 0,
          salarytype: item["Salary Type"],
          minexperience: item["Minimum Experience"] || 0,
          maxexperience: item["Maximum Experience"] || 0,
          experiencetype: item["Experience Type"],
          positions: item["On of Positions"] || 0,
          remotework: item["Remote Work"],

          openingdate: formatDate(item["Opening Date (DD-MM-YYYY)"]),
          closingdate: formatDate(item["Closing Date (DD-MM-YYYY)"]),
          status: item["Status"],
          qualification: item["Qualification"],
          address: item["Address"],
          assignduration: item["Assignment Duration"],
          laptop: item["Laptop Requirement"],
          vehicle: item["Vehicle Requirement"],
          auditdate: formatDate(item["Audit Start Date (DD-MM-YYYY)"]),
          auditenddate: formatDate(item["Audit End Date (DD-MM-YYYY)"]),
          auditenddatetype: item["Audit Date Fixed (Yes/No)"],
          projectcoordinatorname: item["Project Coordinator Name"],
          projectcoordinatoremail: item["Project Coordinator Email"],
        }));

        setExcelData(updatedData);
        console.log(updatedData)

        Notiflix.Notify.success("File uploaded and processed successfully!");
      } catch (error) {
        console.error("Error reading file:", error);
        Notiflix.Notify.failure(
          "Invalid file format! Please upload a valid Excel template."
        );
      }

      Notiflix.Loading.remove();
    };

    reader.readAsArrayBuffer(file);
  };

  const sendCityMail = async () => {
    if (selectedCity.value === "All" || !selectedCity.value) {
      toast.error("Please select a city", {
        autoClose: delay,
        toastId: 1,
      });
      return;
    }

    if (filterJobData.length === 0) {
      toast.error("No jobs available for the selected city", {
        autoClose: delay,
        toastId: 1,
      });
      return;
    }

    setSendingMail(true);
    Notiflix.Loading.standard();

    try {
      const jobIds = filterJobData.map((job) => job.fld_id);

      const response = await PostApiCall.postRequest(
        {
          jobIds: jobIds,
          city: selectedCity.value,
        },
        "Job_CityMailAuditors"
      );

      const res = await response.json();

      if (response.status === 200 || response.status === 201) {
        toast.success(
          res?.message || `Mails sent successfully to ${jobIds.length} jobs`,
          {
            autoClose: delay,
            toastId: 1,
          }
        );
        setMailModalOpen(false);
      } else {
        throw new Error(res?.message || "Failed to send mails");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong", {
        autoClose: delay,
        toastId: 1,
      });
    } finally {
      Notiflix.Loading.remove();
      setSendingMail(false);
    }
  };

  const BulkSubmitHandler = async () => {
    try {
      Notiflix.Loading.standard();
      const errorResponses = [];

      const promises = excelData.map((payload) =>
        PostApiCall.postRequest(payload, "AddJobOpening")
      );

      const results = await Promise.allSettled(promises);

      // Process all results sequentially
      for (let i = 0; i < results.length; i++) {
        const result = results[i];
        const currentPayload = excelData[i]; // Get the corresponding payload

        if (result.status === "fulfilled") {
          try {
            const response = result.value;
            const res = await response.json();

            if (response.status === 200) {
              console.log(res.data, "Success response");
            } else {

              errorResponses.push({
                index: i + 1,
                payload: currentPayload,
                error: res.data,
                rowNumber: i + 2, // Adding 2 because Excel starts at 1 and has header row
              });
            }
          } catch (error) {
            errorResponses.push({
              index: i + 1,
              payload: currentPayload,
              error: error.message,
              rowNumber: i + 2,
            });
          }
        } else {
          // Handle rejected promises
          errorResponses.push({
            index: i + 1,
            payload: currentPayload,
            error: result.reason.message || "Request failed",
            rowNumber: i + 2,
          });
        }
      }

      // Display errors if any
      if (errorResponses.length > 0) {

        setErrorModal({ open: true, error: errorResponses });

        const data = errorResponses.map((ele) => ele.payload);
        const headers = [
          [
            "Title",
            "Job Type",
            "Industry Type",
            "Preference City",
            "Country",
            "State",
            "City",
            "Pincode",
            "Job Description",
            // "Duties",
            "General Terms",
            // "Experience",
            "Client Name",
            // "Employer Name",
            // "Employer Designation",
            // "Employer Email",
            // "Employer Mobile",
            "Minimum Salary",
            "Maximum Salary",
            "Salary Type",
            "Minimum Experience",
            "Maximum Experience",
            "Experience Type",
            "On of Positions",
            "Remote Work",
            "Opening Date (DD-MM-YYYY)",
            "Closing Date (DD-MM-YYYY)",
            "Status",
            // "Approved",
            "Qualification",
            "Address",
            "Assignment Duration",
            "Laptop Requirement",
            "Vehicle Requirement",
            "Audit Start Date (DD-MM-YYYY)",
            "Audit End Date (DD-MM-YYYY)",
            "Audit Date Fixed (Yes/No)",
            "Project Coordinator Name",
            "Project Coordinator Email",
          ],
        ];

        // Create a worksheet
        const ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.sheet_add_aoa(ws, headers, { origin: "A1" });
        // Create a workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Errors");

        // Write the file
        XLSX.writeFile(wb, "error_responses.xlsx");
      }
      setModalOpen(false);
      getJobOpening();
      Notiflix.Loading.remove();
    } catch (error) {
      toast.error(error.message, { autoClose: delay, toastId: 1 });
      Notiflix.Loading.remove();
    }
  };

  const changeStatusHandler = async (values) => {
    try {
      Notiflix.Loading.standard();
      const payload = {
        id: values.fld_id,
        title: values.fld_title,
        type: values.fld_type,
        category: values.fld_category,
        // area: values.area,
        qualification: values?.fld_qualification ?? "",
        address: values.fld_address || "",
        assignduration: values.fld_assignduration || "",
        laptop: values.fld_laptop || "",
        vehicle: values.fld_vehicle || "",

        country: values.fld_country,
        state: values.fld_state,
        city: values.fld_city,
        pincode: values.fld_pincode,
        jobdescription: values.fld_jobdescription,

        skillset: values.fld_skillset,
        experience: values.fld_experience,
        company: values.fld_company || "",
        employername: values.fld_employername,
        employerdesignation: values.fld_employerdesignation,
        employeremail: values.fld_employeremail,
        employermobile: values.fld_employermobile,
        duties: values.fld_duties,
        minsalary: values.fld_minsalary,
        maxsalary: values.fld_maxsalary,
        salarytype: values.salarytype,
        minexperience: values.fld_minexperience,
        maxexperience: values.fld_maxexperience,
        experiencetype: values.fld_experiencetype,
        positions: values.fld_positions,
        remotework: values.fld_remotework,
        closingdate: values.fld_closingdate,
        openingdate: values.fld_openingdate,
        status: values.fld_status == "Active" ? "Inactive" : "Active",
        approved: values.fld_approved,
        auditdate: values.fld_auditdate || "",
        auditenddate: values.fld_auditenddate || "",
        auditenddatetype: values.fld_auditenddatetype || "No",
        area: values.fld_area,
        projectcoordinatorname: values.fld_projectcoordinatorname,
        projectcoordinatoremail: values.fld_projectcoordinatoremail,
      };

      const res = await PostApiCall.postRequest(payload, "UpdateJobOpening");

      const json = await res.json();
      if (res.status === 200 || res.status === 201) {
        Notiflix.Loading.remove();
        getJobOpening();
        toast.success("Updated Successfully", {
          autoClose: delay,
        });
      } else {
        Notiflix.Loading.remove();
        throw new Error(json.data);
      }
    } catch (error) {
      toast.error(error.message || SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
      Notiflix.Loading.remove();
    }
  };

  return (
    <section className="section marginLeftRight">
      {/* breadcrumb */}
      <div className="">
        <div className="w-100 mt-5">
          <BreadCrumb icon={false} subitem={"Publish Job"} />
        </div>

        {/* filter */}

        <Jobtemplate
          isOpen={showModal}
          toggle={() => setShowModal(false)}
          data={modalData} />

        {/* City Filter Card */}
        <Card
          className="border-0 p-4 rdt_Wrapper mb-4"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <Row>
            <Col
              sm="12"
              md="3"
              className="input-icon"
              style={{ borderRadius: 10, zIndex: 4 }}
            >
              <Label>City</Label>
              <Select
                className="React w-100"
                classNamePrefix="select"
                placeholder="Filter by city"
                name="city"
                options={cityOption}
                onChange={(selectedOption) => updateFilterCity(selectedOption)}
                value={selectedCity}
              />
            </Col>
          </Row>
        </Card>

        <Card
          className="border-0 p-4 rdt_Wrapper"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <div className="filter-actions d-flex flex-wrap justify-content-between mb-2">
            <div style={{ flex: "1 1 auto", minWidth: "200px" }}>
              {/* <Input
                className="shadow-sm w-100"
                type="text"
                placeholder="Search..."
                onChange={(e) => updateSearchQuery(e.target.value)}
                value={searchVal}
              /> */}
            </div>
            <div className="mt-md-0 mt-2">
              <button
                className="btns"
                disabled={sendingMail || selectedCity.value === "All" || filterJobData.length === 0}
                onClick={() => setMailModalOpen(true)}
              >
                Send Mail
              </button>
            </div>
          </div>



          <CustomDataTable
            data={filterJobData}
            columns={columns}
            // onRowClick={(row) =>
            //   history({ pathname: "/view-publish-job", state: row })
            // }
            compact={true} // Enables compact styling
          />
        </Card>
      </div>
      {modalOpen === true && (
        <CommonModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          heading={"Download Template & Upload Openings"}
          contentBody={
            <div style={{ marginTop: "0px", zIndex: "50" }}>
              <div style={{ textAlign: "end" }}>
                <button className="btnsAudit" onClick={handleDownload}>
                  <Download /> Download Template
                </button>
              </div>

              <div className="my-2">
                <Label for="nameVertical">
                  Upload Template
                  <span className="mandatory">*</span>
                </Label>
                <Input
                  type="file"
                  name="evidence"
                  accept=".xlsx, .xls"
                  id="nameVertical"
                  onChange={handleFileUpload}
                />
              </div>
            </div>
          }
          onConfirm={BulkSubmitHandler}
          confirmText={"Submit"}
          cancelText={"Cancel"}
          onCancel={() => setModalOpen(false)}
        />
      )}
      {ErrorModal.open === true && (
        <CommonModal
          isOpen={ErrorModal.open}
          toggle={() => setErrorModal({ open: false })}
          heading={"List of Error"}
          contentBody={
            <div style={{ marginTop: "0px", zIndex: "50" }}>
              {ErrorModal?.error?.map((error, index) => {
                return (
                  <div>
                    <strong className="mr-2">{error?.rowNumber} .</strong>
                    <span className="text-danger">{error?.error}</span>
                  </div>
                );
              })}
            </div>
          }
          onConfirm={() => setErrorModal({ open: false })}
          confirmText={""}
          cancelText={"Cancel"}
          onCancel={() => setErrorModal({ open: false })}
        />
      )}
      {mailModalOpen === true && (
        <CommonModal
          isOpen={mailModalOpen}
          toggle={() => setMailModalOpen(false)}
          heading={`Send Mail to ${filterJobData.length} Jobs in ${selectedCity.label}`}
          contentBody={
            <div className="d-grid gap-4">
              <div className="d-grid gap-2 border rounded p-3" style={{ backgroundColor: "#f8f9fa" }}>
                <div>
                  <small style={{ color: "#333" }}>
                    <strong>Selected City:</strong>
                  </small>
                  <p className="mb-2" style={{ fontSize: "13px" }}>
                    {selectedCity.label}
                  </p>
                </div>
                <div>
                  <small style={{ color: "#333" }}>
                    <strong>Number of Jobs:</strong>
                  </small>
                  <p className="mb-2" style={{ fontSize: "13px" }}>
                    {filterJobData.length}
                  </p>
                </div>
                <div>
                  <small style={{ color: "#333" }}>
                    <strong>Job IDs:</strong>
                  </small>
                  <div
                    style={{
                      fontSize: "12px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      padding: "8px",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {filterJobData.map((job) => (
                      <div key={job.fld_id}>
                        {job.fld_code} - {job.fld_title}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          }
          onConfirm={sendCityMail}
          confirmText={"Send Mail"}
          cancelText={"Cancel"}
          onCancel={() => setMailModalOpen(false)}
        />
      )}
    </section>
  );
};

export default CityMailer;